/**
 * Block is used on
 *
 * @returns {{}}
 */
export default () => ({

    loading: true,
    term_id: 0,
    name: '',
    description: '',

    load(shouldScroll) {
        let ref = this;
        ref.name = '';
        ref.description = '';
        this.loading = true;

        fetch('/wp-json/wp/v2/care_type/'+this.term_id, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
            },
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((data) => {
                ref.name = data.name;
                ref.description = data.description;
                this.loading = false;
            })
            .catch((error) => {
                console.error(error);
            });
    },

    showPopup(term_id) {
        this.loading = true;
        this.term_id = term_id;
        this.load();
    },
})